<template>
  <div>
    <div v-show="isShowSelect"
         class="mask"
         @click="isShowSelect = !isShowSelect" />
    <el-popover ref="popover"
                v-model="isShowSelect"
                placement="bottom-start"
                :width="width"
                trigger="manual">
      <el-input :placeholder="options.searchPlaceholder"
                :size="size"
                style="margin-bottom:10px"
                v-model="filterText"
                @change="searchChange">
      </el-input>

      <ul :id="treeDomId"
          ref="catSelectTree"
          v-show="!isSearchTree"
          class="ztree"
          :style="style"
          style="overflow-y: auto;"
          @select="zTreeOnClick"></ul>
      <ul :id="treeDomSearchId"
          class="ztree"
          v-if="isSearchTree"
          :style="style"
          style="overflow-y: auto;"
          @select="zTreeOnClick"></ul>
      <el-select slot="reference"
                 ref="select"
                 v-model="selectedSingleData"
                 :placeholder="placeholder"
                 :disabled="isDisabled"
                 :style="selectStyle"
                 :size="size"
                 :multiple="false"
                 v-bind="$attrs"
                 v-on="$listeners"
                 class="tree-select"
                 clearable
                 @clear="clearNode"
                 @click.native="isShowSelect = !isShowSelect"
                 @change="changeSelect">
        <el-option v-for="item in selectOptions"
                   :key="item.id"
                   :label="item.name"
                   :value="item.id" />
      </el-select>
    </el-popover>
  </div>
</template>

<script>
import '@/libs/js/jquery.ztree.core.js'
import '@/libs/js/jquery.ztree.excheck.js'
// import '@/libs/css/zTreeStyle.css'
import '@/libs/css/treeSelectStyle.css'
export default {
  name: 'zTree',
  model: {
    prop: 'treeSelectValue',
    event: 'change',
  },
  props: {
    // 选择的值
    treeSelectValue: {
      type: Array,
      default() {
        return []
      },
    },
    size: {
      type: String,
      default() {
        return 'small'
      },
    },
    width: {
      type: String,
      default() {
        return '100%'
      },
    },
    height: {
      type: Number,
      default() {
        return 300
      },
    },
    treeDomId: {
      type: String,
      default() {
        return 'selectZtree'
      },
    },
    treeDomSearchId: {
      type: String,
      default() {
        return 'searchTree'
      },
    },
    plat: {
      type: String,
      default: 'tamll',
    },
  },
  data() {
    return {
      placeholder: '加载中...',
      isSearchTree: false, //是否展示搜索后的tree
      style: 'width:' + this.width + ';height:' + this.height + 'px;',
      selectStyle: 'width:' + this.width,
      filterText: '',
      isShowSelect: false, // 是否显示树状选择器
      selectedData: '[]', // 选中的节点
      selectedSingleData: '', // 选中的节点
      treeData: [],
      selectOptions: [],
      catsData: {},
      //   cat_list: {
      //     level1: [],
      //     level2: [
      //       { cat_id: '125046003', ts: '2022-04' },
      //       { cat_id: '50009821', ts: '2022-04' },
      //       { cat_id: '210605', ts: '2022-04' },
      //       { cat_id: '50016091', ts: '2022-04' },
      //     ],
      //     level3: [],
      //     level4: [{ cat_id: '50012193', ts: '2022-04' }],
      //   },
      cat_list: 'all',
      setting: {
        treeId: 'id',
        data: {
          key: {
            name: 'name',
          },
          simpleData: {
            enable: true,
            idKey: 'id',
            pIdKey: 'pId',
            rootPId: 0,
          },
        },
        view: {
          showIcon: false,
          //   showLine: false,
          fontCss: this.zTreefontCss,
          nodeClasses: this.zTreeNodeClasses,
        },
        check: {
          enable: false,
          chkStyle: 'radio',
          radioType: 'all',
          autoCheckTrigger: false,
        },
        callback: {
          onClick: this.zTreeOnClick,
          onCheck: this.zTreeOnCheck,
          beforeClick: this.zTreeBeforeClick,
          beforeCheck: this.zTreeBeforeCheck,
        },
      },
      searchSetting: {
        treeId: 'id',
        async: {
          enable: false,
          url: '',
          autoParam: ['id'],
        },
        data: {
          key: {
            name: 'name',
          },
          simpleData: {
            enable: true,
            idKey: 'id',
            pIdKey: 'pId',
            rootPId: 0,
          },
        },
        view: {
          showIcon: false,
          //   showLine: false,
          fontCss: this.zTreeSearchfontCss,
          nodeClasses: this.zTreeSearchNodeClasses,
        },
        check: {
          enable: false,
          chkStyle: 'radio',
          radioType: 'all',
          autoCheckTrigger: false,
        },
        callback: {
          onClick: this.zTreeSearchOnClick,
          beforeClick: this.zTreeBeforeClick,
          beforeCheck: this.zTreeBeforeCheck,
        },
      },
      zNodes: [],
      options: {
        searchShowParent: true,
        searchPlaceholder: '按enter检索',
        searchKeys: null,
      },
      searchTime: null,
      zTreeObj: {},
      isDisabled: false,
    }
  },
  watch: {
    treeSelectValue: {
      handler(value) {
        this.selectedData = this.treeSelectValue
      },
      deep: true,
    },
    selectedData: {
      handler(value) {
        this.selectedSingleData = this.selectedData[0]
        this.$nextTick(() => {
          this.$refs.popover.updatePopper()
          // 注意主要是这里
        })
      },
      deep: true,
    },
    loginInfo() {
      // 类目展示数据依赖用户权限信息,只有用户信息有值时才加载类目数据
      this.loadCats()
    },
    isShowSelect(val) {
      // 隐藏select自带的下拉框
      this.isSearchTree = false
      this.$refs.select.visible = false
      const zTree = $.fn.zTree.getZTreeObj(this.treeDomId)
      if (val) {
        this.filterText = ''
        if (this.treeSelectValue.length > 0 && this.treeSelectValue[0] != '') {
          let node = zTree.getNodeByParam('id', this.treeSelectValue[0])
          zTree.selectNode(node)
          let target = document.getElementById(node.tId)
          this.$nextTick(() => {
            let targetTop = 0
            if (target.offsetTop > 200) {
              targetTop = target.offsetTop - 200
            }
            this.$refs.catSelectTree.scrollTo(0, targetTop)
          })
        }
      } else {
        // zTree.expandAll(false)
        if (this.treeSelectValue.length > 0 && this.treeSelectValue[0] != '') {
          let node = zTree.getNodeByParam('id', this.treeSelectValue[0])
          this.selectOptions = [
            {
              id: node.id,
              name: node.name,
            },
          ]
        }
      }
      this.$refs.select.blur()
    },
  },
  computed: {
    loginCatList() {
      return this.cat_list
      // return 'notAll'
    },
    loginCatLevel() {
      //   return this.$store.state.user.loginCatlevel
      return this.cat_list
    },
    loginInfo() {
      return {}
    },
  },
  created() {
    // 类目展示数据依赖用户权限信息,只有用户信息有值时才加载类目数据
    if (!window.treeObj) {
      window.treeObj = {
        all: [],
        tamll: [],
        jd: [],
        gamazon: [],
      }
    }
    if (this.cat_list) {
      this.loadCats()
    }
  },
  mounted() {},
  methods: {
    zTreefontCss(treeId, treeNode) {
      if (treeNode.isParent) {
        if (this.ifHit(treeNode, this.filterText, [])) {
          return { color: '#85868A' }
        }
      } else {
        return {}
      }
    },
    zTreeSearchfontCss(treeId, treeNode) {
      if (treeNode.isParent) {
        return { color: '#85868A' }
      } else {
        return { color: '#337ab7' }
      }
    },
    zTreeNodeClasses(treeId, treeNode) {
      var _this = this
      var add = []
      if (_this.ifHit(treeNode, this.selectedSingleData, [])) {
        add.push('search-hit-node')
      }
      return { add: add }
    },
    zTreeSearchNodeClasses(treeId, treeNode) {
      var _this = this
      var add = []
      if (_this.ifHit(treeNode, this.selectedSingleData, [])) {
        add.push('search-hit-node')
      }
      return { add: add }
    },
    ifHit(node, keyWord, serverSearchData) {
      serverSearchData = serverSearchData || []
      var _this = this
      if (
        _this.options.searchKeys instanceof Array &&
        _this.options.searchKeys.length > 0
      ) {
        var flag = false
        $(_this.options.searchKeys).each(function (index, item) {
          if (item.startsWith('like_')) {
            if (node[item.replace('like_', '')].indexOf(keyWord) != -1) {
              flag = true
              return
            }
          } else if (item.startsWith('eq_')) {
            if (node[item.replace('eq_', '')] === keyWord) {
              flag = true
              return
            }
          }
        })
        return flag
      } else {
        return (
          node[_this.setting.data.key.name].indexOf(keyWord) != -1 ||
          _.includes(serverSearchData, node.id)
        )
      }
    },
    zTreeOnClick(event, treeId, treeNode) {
      this.selectOptions = [
        {
          id: treeNode.id,
          name: treeNode.name,
        },
      ]
      this.selectedSingleData = treeNode.id
      this.isShowSelect = false
      this.$emit('cidChange', this.selectOptions)
      //   var zTree = $.fn.zTree.getZTreeObj(this.treeDomId)
      //   zTree.checkNode(treeNode, !treeNode.checked, true)
    },
    zTreeSearchOnClick(event, treeId, treeNode) {
      this.selectOptions = [
        {
          id: treeNode.id,
          name: treeNode.name,
        },
      ]
      this.selectedSingleData = treeNode.id
      this.isShowSelect = false
      this.$emit('cidChange', this.selectOptions)
      //   var zTree = $.fn.zTree.getZTreeObj(this.treeDomId)
      //   zTree.checkNode(treeNode, !treeNode.checked, true)
    },
    zTreeOnCheck(event, treeId, treeNode) {
      //   var zTree = $.fn.zTree.getZTreeObj(this.treeDomId)
      //   zTree.selectNode(treeNode)
    },
    zTreeBeforeClick(treeId, treeNode) {
      return !treeNode.isParent //当是父节点 返回false 不让选取
    },
    zTreeBeforeCheck(treeId, treeNode) {
      return !treeNode.isParent //当是父节点 返回false 不让选取
    },
    clearNode() {
      this.$emit('clear')
      var treeObj = $.fn.zTree.getZTreeObj(this.treeDomId)
      treeObj.cancelSelectedNode()
      this.selectedSingleData = ''
      this.isShowSelect = false
    },
    changeSelect() {},
    searchChange(value) {
      if (value.trim() !== '') {
        this.isSearchTree = true
        this.doSearch(value)
      } else {
        this.isSearchTree = false
      }
    },
    doSearch(searchWord) {
      var _this = this
      /*异步执行低频率执行解决性能问题*/
      if (_this.searchTime) {
        clearTimeout(_this.searchTime)
      }
      _this.searchTime = setTimeout(function () {
        var serverSearch =
          _this.options.serverSearch ||
          function () {
            return new Promise(function (resolve, reject) {
              resolve(null)
            })
          }
        serverSearch(searchWord).then(function (serverSearchData) {
          let searchzTreeObj = _this.zTreeObj
          var nodeList = searchzTreeObj.getNodesByFilter(function (node) {
            return _this.ifHit(node, searchWord, serverSearchData)
          }) //通过关键字模糊搜索
          var datasMap = {}
          $(nodeList).each(function (index, item) {
            datasMap[item['id']] = item
          })
          if (_this.options.searchShowParent) {
            $(nodeList).each(function (index, node) {
              _this.loadParents(node, datasMap)
            })
          }
          var _zNodes = _.values(datasMap)
          _this.initSearchTree(_zNodes, searchWord, serverSearchData)
        })
      }, 100)
    },
    loadParents(node, datasMap) {
      var parent = node.getParentNode()
      if (parent) {
        var copyparent = $.extend({}, parent)
        copyparent.children = null
        copyparent.open = true
        datasMap[parent['id']] = copyparent
        this.loadParents(parent, datasMap)
      } else {
        return
      }
    },
    initSearchTree(data) {
      var _this = this
      $.fn.zTree.init($('#' + this.treeDomSearchId), _this.searchSetting, data)
    },
    async loadCats() {
      let rawData = await this.loadSiteCats()
      this.catsData = rawData
      this.getData()
    },
    loadSiteCats() {
      return new Promise((resolve, reject) => {
        try {
          if (this.plat != 'jd' && !window.cache_cat) {
            // 加载淘系类目数据
            const s = document.createElement('script')
            s.type = 'text/javascript'
            s.src = 'https://chance.mktindex.com/static/chance/json/bigcats.js'
            document.body.appendChild(s)
            s.onload = function () {
              let datas = window.cache_cat
              resolve(datas)
            }
          } else if (this.plat == 'jd' && !window.cache_cat_jd) {
            // 加载京东类目数据
            const s_jd = document.createElement('script')
            s_jd.type = 'text/javascript'
            s_jd.src =
              'https://comment.mktindex.com/static/lingting/json/bigcats_jd.js'
            document.body.appendChild(s_jd)
            s_jd.onload = function () {
              let datas = window.cache_cat_jd
              resolve(datas)
            }
          } else {
            let datas =
              this.plat != 'jd' ? window.cache_cat : window.cache_cat_jd
            resolve(datas)
          }
        } catch (err) {
          reject(err)
        }
      })
    },
    async getData() {
      let arrs = []
      if (this.loginCatList == 'all') {
        arrs = this.catsData.result.bigCategory
      } else {
        Object.keys(this.cat_list).forEach((v) => {
          this.cat_list[v].forEach((o, i) => {
            let parents = this.get_parents(o.cat_id)
            arrs.push(_.last(parents))
          })
        })
      }
      // this.zNodes = this.transformPickerOptions(arrs)
      // this.initSelectzTree()
      if (window.treeObj[this.plat].length > 0) {
        setTimeout(() => {
          this.zNodes = window.treeObj[this.plat]
          this.isDisabled = false
          this.initSelectzTree()
          this.placeholder = '请选择'
        }, 200)
      } else {
        this.startWorker(arrs, this.cat_list).then((res) => {
          this.zNodes = res
          window.treeObj[this.plat] = res
          this.isDisabled = false
          this.initSelectzTree()
          this.placeholder = '请选择'
        })
      }
    },
    initSelectzTree() {
      $.fn.zTree.init($('#' + this.treeDomId), this.setting, this.zNodes)
      // .expandAll(false)
      var zTree = $.fn.zTree.getZTreeObj(this.treeDomId)
      this.zTreeObj = zTree
      if (this.treeSelectValue.length > 0 && this.treeSelectValue[0] != '') {
        var node = zTree.getNodeByParam('id', this.treeSelectValue[0])
        this.selectOptions = [
          {
            id: node.id,
            name: node.name,
          },
        ]
        this.selectedSingleData = node.id
        zTree.checkNode(node, true, true)
        zTree.selectNode(node)
      }
    },
    startWorker(cats, cat_list) {
      const actions = [
        {
          message: 'transformPickerOptions',
          func: function (cats, childrenList, cat_list) {
            return _transformPickerOptions(cats, childrenList, cat_list)
            function _transformPickerOptions(_cats, _childrenList, cat_list) {
              let indexArr = []
              for (let key in _cats) {
                let catId = _cats[key]
                if (cat_list == 'all') {
                  let { category_id, is_parent, chd, name, only_show } =
                    _childrenList[catId]
                  let _cat = {
                    id: category_id,
                    name: name,
                    chkDisabled: is_parent,
                    is_parent,
                  }
                  if (is_parent) {
                    let _children = _transformPickerOptions(
                      chd,
                      _childrenList,
                      cat_list
                    )
                    if (_children.length) {
                      _cat.children = _children
                    }
                  }
                  indexArr.push(_cat)
                } else {
                  let isArr = []
                  if (_childrenList[catId]) {
                    let { category_id, is_parent, chd, name, only_show } =
                      _childrenList[catId]
                    only_show = check_permission(
                      catId,
                      _childrenList,
                      cat_list
                    )[1]
                    let has_priv = check_permission(
                      catId,
                      _childrenList,
                      cat_list
                    )[0]
                    let _cat = null
                    let index = isArr.findIndex((item) => {
                      return item == category_id
                    })
                    if (has_priv && index == -1) {
                      _cat = {
                        id: category_id,
                        name: name,
                        // disabled: only_show == true,
                        chkDisabled: is_parent,
                        is_parent: is_parent,
                      }
                      isArr.push(category_id)
                      indexArr.push(_cat)
                    } else {
                      return
                    }
                    if (is_parent) {
                      let _children = _transformPickerOptions(
                        chd,
                        _childrenList,
                        cat_list
                      )
                      if (_children.length) {
                        _cat.children = _children
                      }
                    }
                  } else {
                    return false
                  }
                }
              }
              return indexArr
            }
            function check_permission(cid, _childrenList, cat_level_list) {
              var pids = get_parents(cid, _childrenList)
              var has_priv = false,
                only_show = true
              //1.父类目是否有权限
              pids.forEach(function (pid, i) {
                var cat = _childrenList[pid]
                var level = cat.level
                cat_level_list['level' + level].forEach(function (o, j) {
                  if (o.cat_id == pid) {
                    has_priv = true
                    only_show = false
                  }
                })
              })
              //2.子类目有权限的，需展示父类目
              if (!has_priv) {
                Object.keys(cat_level_list).forEach(function (v) {
                  cat_level_list[v].forEach(function (o, i) {
                    var parents = get_parents(o.cat_id, _childrenList)
                    if (parents.indexOf(cid) >= 0) {
                      has_priv = true
                      only_show = true
                    }
                  })
                })
              } else {
                only_show = false
              }

              return [has_priv, only_show]
            }
            function get_parents(cid, _childrenList) {
              let count = 0
              var cat = _childrenList[cid]
              var pids = [cid]
              while (cat.parent_id != '0' && count < 4) {
                pids.push(cat.parent_id)
                cat = _childrenList[cat.parent_id]
                count += 1
              }
              return pids
            }
          },
        },
      ]
      let worker = this.$worker.create(actions)
      let postMessageActionName = 'transformPickerOptions'
      return worker.postMessage(postMessageActionName, [
        cats,
        this.catsData.result.childrenList,
        cat_list,
      ])
    },
    transformPickerOptions(cats) {
      var self = this
      let childrenList = this.catsData.result.childrenList
      return _transformPickerOptions(cats)
      function _transformPickerOptions(_cats) {
        let indexArr = []
        return _.compact(
          _.map(_cats, function (catId) {
            if (self.loginCatList == 'all') {
              let { category_id, is_parent, chd, name, only_show } =
                childrenList[catId]
              let _cat = {
                id: category_id,
                name: name,
                chkDisabled: is_parent,
                is_parent,
              }
              if (is_parent) {
                let _children = _transformPickerOptions(chd)
                if (_children.length) {
                  _cat.children = _children
                }
              }
              return _cat
            } else {
              if (childrenList[catId]) {
                let { category_id, is_parent, chd, name, only_show } =
                  childrenList[catId]
                only_show = self.check_permission(catId)[1]
                let has_priv = self.check_permission(catId)[0]
                let _cat = null
                let index = indexArr.findIndex((item) => {
                  return item == category_id
                })
                if (has_priv && index == -1) {
                  _cat = {
                    id: category_id,
                    name: name,
                    // disabled: only_show == true,
                    chkDisabled: is_parent,
                    is_parent: is_parent,
                  }
                  indexArr.push(category_id)
                } else {
                  return
                }
                if (is_parent) {
                  let _children = _transformPickerOptions(chd)
                  if (_children.length) {
                    _cat.children = _children
                  }
                }
                return _cat
              } else {
                return false
              }
            }
          })
        )
      }
    },
    check_permission(cid) {
      var self = this
      let childrenList = this.catsData.result.childrenList
      var pids = this.get_parents(cid)
      var has_priv = false,
        only_show = true
      //1.父类目是否有权限
      pids.forEach(function (pid, i) {
        var cat = childrenList[pid]
        var level = cat.level
        self.cat_list['level' + level].forEach(function (o, j) {
          if (o.cat_id == pid) {
            has_priv = true
            only_show = false
          }
        })
      })
      //2.子类目有权限的，需展示父类目
      if (!has_priv) {
        Object.keys(self.cat_list).forEach(function (v) {
          self.cat_list[v].forEach(function (o, i) {
            var parents = self.get_parents(o.cat_id)
            if (parents.indexOf(cid) >= 0) {
              has_priv = true
              only_show = true
            }
          })
        })
      } else {
        only_show = false
      }

      return [has_priv, only_show]
    },
    get_parents(cid) {
      let childrenList = this.catsData.result.childrenList
      var cat = childrenList[cid]
      var pids = [cid]
      while (cat.parent_id != '0') {
        pids.push(cat.parent_id)
        cat = childrenList[cat.parent_id]
      }
      return pids
    },
    getCatPath(cid) {
      let that = this
      let path = getParent(cid)
      if (that.maxLevel > path.length && !that.isPc) {
        path = path.concat(_.fill(Array(that.maxLevel - path.length), '-'))
      }
      return path
      function getParent(cid, path = [cid]) {
        if (
          this.catsData.result.childrenList[cid] &&
          this.catsData.result.childrenList[cid].parent_id
        ) {
          if (this.catsData.result.childrenList[cid].parent_id !== '0') {
            let parentId = this.catsData.result.childrenList[cid].parent_id
            return getParent(parentId, _.concat([parentId], path))
          } else {
            return path
          }
        } else {
          return [cid]
        }
      }
    },
  },
}
</script>

<style  scoped lang="less">
.mask {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  opacity: 0;
}
.common-tree {
  overflow: auto;
}
</style>

<style>
</style>
